import * as types from '../constants/ActionTypes-privilegeElement';


export const setPrivilegeElement = element => ({
  type: types.SET_ELEMENT,
  payload: element,
  reducer_type: 'reducer_privilege'
});
  
